<template>
  <div class="flex flex-col w-1/2 md:w-1/3 mx-auto text-black">
    <div
        class="mt-20 border border-gray-700 rounded py-2 shadow-lg">
            {{ $t('admin.subtitle') }}
      </div>
    <form
      class="flex flex-col justify-center mx-auto text-black"
      action="#"
      @submit.prevent="submit">
        <div class="flex flex-col md:flex-row justify-between">
            <input
              type="text" v-model="credentials.firstname"
              class="mt-10 w-2/5 border-b border-gray-500 px-2 outline-none
              text-black"
              :placeholder="$t('register.first')">
            <input
              type="text" v-model="credentials.lastname"
              class="mt-10 w-2/5 border-b border-gray-500 px-2 outline-none
              text-black"
              :placeholder="$t('register.last')">
        </div>
        <div class="flex flex-col">
            <input
              type="email" v-model="credentials.email"
              class="mt-10 border-b border-gray-500 px-2 outline-none
              text-black"
              placeholder="Email">
            <input
              type="password" v-model="credentials.password"
              class="mt-10 border-b border-gray-500 px-2 outline-none
              text-black"
              placeholder="Password">
            <input
              type="Password" v-model="credentials.password_confirmation"
              class="mt-10 border-b border-gray-500 px-2 outline-none
              text-black"
              :placeholder="$t('register.confirm')">
            <input
              type="text" v-model="credentials.lang"
              class="mt-20 border-b border-gray-500 px-2 outline-none
              text-black"
              :placeholder="$t('register.lang')">
        </div>
        <button
          class="w-1/4 mx-auto mt-20 border rounded py-2 shadow-lg mb-10 border-gray-700"
          type="submit">
            {{ $t('register.register') }}
        </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';

export default {
  data() {
    return {
      credentials: {
        firstname: '',
        lastname: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        lang: '',
      },

    };
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    ...mapActions({
      register: 'auth/registerTeacher',
    }),

    async submit() {
      this.credentials.name = `${this.capitalLetter(this.credentials.firstname)} ${this.capitalLetter(this.credentials.lastname)}`;
      await this.register(this.credentials);

      // eslint-disable-next-line no-alert
      this.createNotification('success', `Teacher ${this.credentials.name} has been added`);

      this.goToDashboard();
      // this.$router.replace({ name: 'Home' });
    },

  },
};
</script>
